import {
    PRIZE_REQUEST_START,
    PRIZE_REQUEST_SUCCESS,
    PRIZE_REQUEST_FAILED,
    PRIZE_REQUEST_NO_PERMISSION,
    PRIZE_INSERT,
    PRIZE_UPDATE,
    PRIZE_DELETE,
    PRIZE_OPEN_UPDATE_FORM,
    PRIZE_UPDATE_FIELD,
    PRIZE_STORES_DAY,
    PRIZE_STORES_DAY_UPDATE,
    PRIZE_STORES_DAY_MANAGER,
    PRIZE_STORES_DAY_MANAGER_ADD,
    PRIZE_STORES_DAY_MANAGER_UPDATE
} from '../actions/PrizeActions';


const initialState = {
    status: 'Initialize'
};

export default function PrizeReducer(state = initialState, action) {

    if (!action) {
        return state;
    }

    switch (action.type) {
        case PRIZE_REQUEST_START:
            return {
                ...state, status: 'request', country: action.country, date: action.date,
                product: action.product,
                platform: action.platform
            };
        case PRIZE_REQUEST_SUCCESS:
            return {...state, status: 'success', data: action.data};
        case PRIZE_REQUEST_NO_PERMISSION:
            return {...state, status: 'no_permission'};
        case PRIZE_REQUEST_FAILED:
            return {...state, status: 'error'};
        case PRIZE_OPEN_UPDATE_FORM:
            return {...state,errorUpdate:false,prizeInEdit:action.order};
        case PRIZE_UPDATE_FIELD:
            var updatedAffiliate = {...state.prizeInEdit};
            updatedAffiliate[action.field] = action.value;
            return {...state,errorUpdate:false, prizeInEdit: updatedAffiliate};
        case PRIZE_INSERT:
            /*const modifiedCustomers = [...state.data, action.customer];

            return {...state, data: modifiedCustomers };*/
            var modifiedCustomers = [];
            for (var index in state.data){
                modifiedCustomers.push(state.data[index] );
            }

            modifiedCustomers.push(action.customer);

            return {...state,data:modifiedCustomers,errorUpdate:false};
        case PRIZE_UPDATE:

            /*const updatedCustomers = [...state.data];
            updatedCustomers[action.index] = action.customer;

            return {...state, data: updatedCustomers };*/

            let tmp = [...state.data];
            let indexD = tmp.map(e => e.day).indexOf(action.day);

            var updatedCustomers = [];
            for (var index in state.data[indexD].dataArr){

                if (state.data[indexD].dataArr[index].id === action.prize.id){

                    updatedCustomers.push(action.prize);
                }
                else{
                    updatedCustomers.push(state.data[indexD].dataArr[index]);

                }
            }
            tmp[indexD].dataArr = updatedCustomers;

            return {...state,data:tmp,errorUpdate:false};

        case PRIZE_DELETE:

            let tmpDel = [...state.data];
            let indexDel = tmpDel.map(e => e.day).indexOf(action.day);

            var updatedCustomers = [];
            for (var index in state.data[indexDel].dataArr){

                if (state.data[indexDel].dataArr[index].id !== action.id){

                    updatedCustomers.push(state.data[indexDel].dataArr[index]);
                }
            }
            tmpDel[indexDel].dataArr = updatedCustomers;

            return {...state,data:tmpDel,errorUpdate:false};
        case PRIZE_STORES_DAY:
            return {...state, storesDay: action.stores};
        case PRIZE_STORES_DAY_MANAGER:
            return {...state, storesDayManager: action.stores};
        case PRIZE_STORES_DAY_MANAGER_ADD:
            let isPresent = state.storesDayManager.findIndex(e => {
                return e.managerId === action.id;
            });

            var updatedCustomers = [];

            for (var index in state.storesDayManager){
                updatedCustomers.push(state.storesDayManager[index]);
            }

            if(isPresent === -1) {
                updatedCustomers.push({managerId: action.id, managerName: action.name,
                    dayStores: [{day: 1, storesDay: ''},{day: 2, storesDay: ''},{day: 3, storesDay: ''},{day: 4, storesDay: ''},{day: 5, storesDay: ''}]})
            }

            return {...state,storesDayManager:updatedCustomers,errorUpdate:false};
        case PRIZE_STORES_DAY_MANAGER_UPDATE:

            var updatedCustomers = [];
            for(var index in state.storesDayManager) {
                if(state.storesDayManager[index].managerId === action.manager) {

                    var updatedDays = [];

                    for(var index2 in state.storesDayManager[index].dayStores) {
                        if (state.storesDayManager[index].dayStores[index2].day === action.day){
                            updatedDays.push({day: action.day, storesDay: action.stores});
                        }
                        else{
                            updatedDays.push(state.storesDayManager[index].dayStores[index2]);
                        }
                    }

                    updatedCustomers.push({managerId: state.storesDayManager[index].managerId,
                        managerName : state.storesDayManager[index].managerName,
                        dayStores: updatedDays});

                }
                else {
                    updatedCustomers.push(state.storesDayManager[index]);
                }
            }

            return {...state,storesDayManager:updatedCustomers,errorUpdate:false};
        case PRIZE_STORES_DAY_UPDATE:

            var updatedCustomers = [];
            for (var index in state.storesDay){

                if (state.storesDay[index].day === action.day){

                    updatedCustomers.push({day: action.day, storesDay: action.stores});
                }
                else{
                    updatedCustomers.push(state.storesDay[index]);
                }
            }

            return {...state,storesDay:updatedCustomers,errorUpdate:false};
        default:
            return state;
    }
}
